import {Injectable} from '@angular/core';
import {NestApiProvider} from '../../nest-api';
import {Observable} from 'rxjs/Rx';
import {RequestClearIrregularDto} from './sf-payprocess.dto';

@Injectable()
export class SfPayprocessApi {

  private readonly service: string = 'payroll';
  private readonly model: string = 'SFPayProcesses';

  constructor(
      private nestApiProvider: NestApiProvider,
  ) {
  }

  public taxCalc(payload: any): Observable<any> {
    const method: string = 'POST';
    const func: string = 'taxCalc';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public clearIrregular(payload: RequestClearIrregularDto): Observable<any> {
    const method: string = 'POST';
    const func: string = 'clearIreguler';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public getPaidPayroll(): Observable<any> {
    const method: string = 'GET';
    const func: string = 'paidPayroll';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public getEmpPayPeriod(periodCode: any = {}, paydate: any = {}): Observable<any> {
    const method: string = 'GET';
    const func: string = 'getEmpPayPeriod';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof periodCode !== 'undefined' && periodCode !== null) urlParams.periodCode = periodCode;
    if (typeof paydate !== 'undefined' && paydate !== null) urlParams.paydate = paydate;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request(method, url, func, params, body);
  }

  public getPaidPayroll2(periodCode: any): Observable<any> {
    const method: string = 'GET';
    const func: string = 'paidPayroll2';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof periodCode !== 'undefined' && periodCode !== null) urlParams.periodCode = periodCode;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public updateEssVerify(payload: any): Observable<any> {
    const method: string = 'POST';
    const func: string = 'updateEssVerify';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public getAllowDeductPeriod(periodCode: any = {}, dispjams: any = {}): Observable<any> {
    const method: string = 'GET';
    const func: string = 'getAllowDeductPeriod';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof periodCode !== 'undefined' && periodCode !== null) urlParams.periodCode = periodCode;
    if (typeof dispjams !== 'undefined' && dispjams !== null) urlParams.dispjams = dispjams;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public verifyprocess(periodCode: any = {}, paydate: any = {}): Observable<any> {
    const method: string = 'GET';
    const func: string = 'verifyprocess';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof periodCode !== 'undefined' && periodCode !== null) urlParams.periodCode = periodCode;
    if (typeof paydate !== 'undefined' && paydate !== null) urlParams.paydate = paydate;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request(method, url, func, params, body);
  }

  public getReligion(): Observable<any> {
    const method: string = 'GET';
    const func: string = 'getReligion';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public getMarital(): Observable<any> {
    const method: string = 'GET';
    const func: string = 'getMarital';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public unPublish(periodCode: any = {}, paydate: any = {}): Observable<any> {
    const method: string = 'GET';
    const func: string = 'unpublish';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof periodCode !== 'undefined' && periodCode !== null) urlParams.periodCode = periodCode;
    if (typeof paydate !== 'undefined' && paydate !== null) urlParams.paydate = paydate;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request(method, url, func, params, body);
  }

  public taxOptionsValue(code: any): Observable<any> {
    const method: string = 'GET';
    const func: string = 'taxOptionsValue';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof code !== 'undefined' && code !== null) urlParams.code = code;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/payroll/sf-payprocess/sf-payprocess.api.ts